import React, {FC, useState} from "react";
import { Input } from "@jane/lib/src/components/form/Input";
import {Broadcast, useApiCall} from "../../../lib/src/api";
import {useToasts} from "../../../lib/src/toasts/toasts";
import {config} from "../config";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const EditBroadcastContentModal: FC<{ broadcast: Broadcast, onFinished: () => void }> = (props) => {
  const { broadcasts } = useApiCall(config)
  const [subject, setSubject] = useState<string>(props.broadcast.subject ?? '')
  const [message, setMessage] = useState<string>(props.broadcast.message ?? '')
  const {showToast} = useToasts()

  const submit = async () => {
    await broadcasts.update(props.broadcast.id, {
      subject: subject,
      message: message,
    }).catch(() => {
      showToast('Oeps', 'Er is iets misgegaan bij het bewerken.')
    })
    props.onFinished()
  }

  return <div className={'space-y-3'}>
    <Input label={'Onderwerp'} type={'text'} value={subject} onChange={setSubject} maxWidth={"full"} />
    <Input label={'Bericht'} type={'textarea'} value={message} onChange={setMessage} maxWidth={"full"} />
    <ModalFooter text={'Opslaan'} onSubmit={async () => {
      await submit()
      close()
    }} />
  </div>
}